import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';

interface ExportDashboardModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending?: boolean;
  isError?: boolean;
}

const ExportDashboardModal = ({
  open,
  onClose,
  onConfirm,
  isPending = false,
  isError = false
}: ExportDashboardModalProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#1565c0'
      }}
    >
      Export Dashboard
      <IconButton onClick={onClose} size="small">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2">
        We&apos;ll email your export to your account email address. It will include:
      </Typography>
      {/* application.css adds a middot to every li::before, which doubles up
          with the list's own marker. */}
      <Box component="ul" sx={{ my: 1, pl: 3, '& li::before': { content: 'none' } }}>
        <Typography component="li" variant="body2">
          A PDF of the dashboard widgets.
        </Typography>
        <Typography component="li" variant="body2">
          A CSV of the Educator table data.
        </Typography>
      </Box>
      <Typography variant="body2">
        Both files will reflect your current top level filters.
      </Typography>

      {isError ? (
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          Something went wrong starting your export. Please try again.
        </Typography>
      ) : null}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          color="secondary"
          disabled={isPending}
          onClick={onConfirm}
          size="small"
          variant="contained"
        >
          <Typography variant="button">Confirm</Typography>
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);

export default ExportDashboardModal;
